import { Box, Divider, Grid, Typography } from "@mui/material";
import React, { Fragment, useEffect, useState } from "react";
import CommonCard from "../../common/components/CommonCard";
import theme from "../../theme";
import CommonButton from "../../common/components/CommonButton";
import { Add } from "@mui/icons-material";
import { Academics, DisplayGrade, FirstTimes, ProficiencyLevels, Profiles, ProfilesObj, ProjectDurations, ProjectTypeObj, ProjectTypes, removeEmptyFields, Status, StudentGrade, Types, UserTypeId } from "../../common/const";
import CommonDialog from "../../common/components/CommonDialog";
import CommonFormField from "../../common/components/CommonFormField";
import CommonSelect from "../../common/components/CommonSelect";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { setLoading } from "../../features/authSlice";
import { createProjectResearch, getProjectResearch, updateProjectResearch } from "../../api/resourceApi";
import { showNotification } from "../../common/components/Notification/ToastifyNotification";
import { setProjectList } from "../../features/projectSlice";
import { getProjectList } from "../../api/projectBankApi";
import LoadingSpinner from "../../common/components/LoadingSpinner";
import CommonGradeButton from "./CommonGradeButton";

const ResearchInfo = () => {
    const dispatch = useDispatch();
    const { user, loading } = useSelector((state) => state.auth);
    const [filter, setFilter] = useState('RESEARCH');
    const { projectList } = useSelector((state) => state.project);
    const [currentGrade, setCurrentGrade] = useState(user?.student_current_grade);
    const [dialogOpen, setDialogOpen] = useState(false);
    const [errors, setErrors] = useState({});
    const [projects, setProjects] = useState([]);
    const [filterProject, setFilterProject] = useState([]);
    const [formData, setFormData] = useState({
        projectInfo: {
            profile: Profiles[0].value,
            projectype: ProjectTypes[0].value,
            status: '',
            firstTime: FirstTimes[0].value,
            name: '',
            bankid: '',
            type: '',
            projectlevel: '',
            duration: '',
            totalhour: '',
            startdate: '',
            enddate: '',
        }
    });

    const validateField = (name, value, projectInfo) => {
        switch (name) {
            case 'name':
                if (!value && projectInfo.projecttype === ProjectTypeObj.ext) return `${projectInfo.profile === ProfilesObj.Research ? 'Research' : 'Project'} Name is required`;
                return '';
            case 'bankid':
                if (!value && projectInfo.projecttype === ProjectTypeObj.dcp) return `Project Name is required`;
                return '';
            case 'type':
                if (!value) return `${projectInfo.profile === ProfilesObj.Research ? 'Research' : 'Project'} Type is required`;
                return '';
            case 'status':
                if (!value) return 'Status is required';
                return '';
            default:
                return '';
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setFormData((prev) => ({
            ...prev,
            projectInfo: {
                ...prev.projectInfo,
                [name]: value,
            },
        }));
        // Clear error for the field being changed
        if (errors[name]) {
            const error = validateField(name, value, formData.projectInfo);
            if (!error) {
                setErrors(prev => ({ ...prev, [name]: undefined }));
            } else {
                setErrors(prev => ({ ...prev, [name]: error }));
            }
        }
    };

    const validateForm = () => {
        const newErrors = {};
        Object.keys(formData.projectInfo).forEach(key => {
            const error = validateField(key, formData.projectInfo[key], formData.projectInfo);
            if (error) newErrors[key] = error;
        });
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async () => {
        try {
            if (!validateForm()) return;
            const data = removeEmptyFields({
                "project_profile": formData.projectInfo.profile,
                "project_name": (formData.projectInfo.bankid !== '' && formData.projectInfo.bankid !== null) ? projectList.find((a) => a.value === formData.projectInfo.bankid)?.label : formData.projectInfo.name !== '' ? formData.projectInfo.name : '',
                "project_level": formData.projectInfo.projectlevel !== '' ? formData.projectInfo.projectlevel : null,
                "project_source": formData.projectInfo.projectype !== '' ? formData.projectInfo.projectype : null,
                "project_type": formData.projectInfo.type,
                "project_bank_id": (formData.projectInfo.bankid !== '' && formData.projectInfo.bankid !== null) ? formData.projectInfo.bankid : null,
                "it_first_time": formData.projectInfo.firstTime !== '' ? formData.projectInfo.firstTime : null,
                "project_duration": formData.projectInfo.duration,
                "status": formData.projectInfo.status,
                "total_hours": formData.projectInfo.totalhour,
                "is_active": true,
                "start_date": formData.projectInfo.startdate !== '' ? new Date(formData.projectInfo.startdate).toISOString() : null,
                "end_date": formData.projectInfo.enddate !== '' ? new Date(formData.projectInfo.enddate).toISOString() : null,
                "student_id": user.student_id,
                "student_grade": currentGrade,
            });
            let subjecResponse;
            dispatch(setLoading({
                loading: true
            }));
            if (formData.projectInfo?.project_id && formData.projectInfo?.project_id !== '') {
                subjecResponse = await updateProjectResearch(formData.projectInfo?.project_id, data);
            } else {
                subjecResponse = await createProjectResearch(data);
            }
            if (subjecResponse) {
                dispatch(setLoading({
                    loading: false
                }));
                if (formData.projectInfo?.project_id !== '') {
                    showNotification(`${formData.projectInfo.profile === ProfilesObj.Research ? 'Research' : 'Project'} updated successfully`, 'success');
                } else {
                    showNotification(`${formData.projectInfo.profile === ProfilesObj.Research ? 'Research' : 'Project'} added successfully`, 'success');
                }
                setDialogOpen(false);
                getProjects();
                setFormData((prev) => ({
                    ...prev,
                    projectInfo: {
                        project_id: '',
                        profile: Profiles[0].value,
                        projectype: ProjectTypes[0].value,
                        status: '',
                        firstTime: FirstTimes[0].value,
                        name: '',
                        bankid: '',
                        type: '',
                        projectlevel: '',
                        duration: '',
                        totalhour: '',
                        startdate: '',
                        enddate: '',
                    },
                }));
            }
        } catch (err) {
            const errorMessage = err.response?.data?.errors?.[0]?.message || err.response?.data?.message || err?.response?.data?.error;
            dispatch(setLoading({
                loading: false
            }));
            showNotification(errorMessage, 'error');
        }
    }

    const getProjects = async () => {
        try {
            dispatch(setLoading({
                loading: true
            }));
            const subjectRes = await getProjectResearch(user?.student_id, currentGrade);
            if (currentGrade === null) {
                setCurrentGrade(subjectRes.data?.[0]?.student_grade || StudentGrade[0].value);
            }
            setProjects(subjectRes.data);
            setFilterProject(subjectRes.data.filter((a) => a.project_profile === filter));
            dispatch(setLoading({
                loading: false
            }));
        } catch (err) {
            const errorMessage = err.response?.data?.errors?.[0]?.message || err.response?.data?.message || err?.response?.data?.error;
            showNotification(errorMessage, 'error');
            dispatch(setLoading({
                loading: false
            }));
        }
    }

    useEffect(() => {
        if (user?.student_id) {
            getProjects();
        }
    }, [user?.student_id, filter, currentGrade]);

    const getProject = async () => {
        const response = await getProjectList();
        if (response?.data?.data?.length > 0) {
            dispatch(setProjectList({
                list: response.data.data.map((a) => ({
                    label: a.project_name,
                    value: a.project_bank_id
                }))
            }))
        }
        dispatch(setLoading({
            loading: false
        }));
    }

    useEffect(() => {
        dispatch(setLoading({
            loading: true
        }));
        getProject();
    }, []);

    const getMinDate = () => {
        const date = formData.projectInfo.startdate ? new Date(formData.projectInfo.startdate) : new Date();
        date.setDate(date.getDate() + 1); // Add 7 days
        return date.toISOString().split('T')[0];
    };

    return (
        <Fragment>
            {loading && (
                <LoadingSpinner />
            )}
            <CommonDialog
                open={dialogOpen}
                size="sm"
                title={
                    <Fragment>
                        <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
                            <Typography sx={{ fontWeight: 600, fontSize: 18 }}>{formData?.projectInfo?.project_id && formData?.projectInfo?.project_id !== '' ? `Edit Research/Projects` : 'Add Research/Projects'}</Typography>
                        </Box>
                        <Divider />
                    </Fragment>
                }
                content={
                    <Grid container spacing={1.5} mt={0.5} mb={2}>
                        <Grid item xs={12} md={formData.projectInfo?.profile === ProfilesObj.Project ? 6 : 12}>
                            <CommonSelect
                                label="Select Profile"
                                name="profile"
                                value={formData.projectInfo.profile}
                                onChange={handleInputChange}
                                placeholder="Select Profile"
                                options={Profiles}
                            />
                        </Grid>
                        {formData.projectInfo.profile === ProfilesObj.Project && (
                            <Grid item xs={12} md={6}>
                                <CommonSelect
                                    label="Project Type (DCP/External)"
                                    name="projectype"
                                    value={formData.projectInfo.projectype}
                                    onChange={handleInputChange}
                                    placeholder="Select Project Type"
                                    options={ProjectTypes}
                                />
                            </Grid>
                        )}
                        <Grid item xs={12} md={6}>
                            <CommonSelect
                                label="Status"
                                name="status"
                                value={formData.projectInfo.status}
                                onChange={handleInputChange}
                                placeholder="Select Status"
                                error={errors.status}
                                options={formData.projectInfo.profile === ProfilesObj.Project ? Status : Academics}
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <CommonSelect
                                label="Is it First Time/Expanding Existing"
                                name="firstTime"
                                value={formData.projectInfo.firstTime}
                                onChange={handleInputChange}
                                placeholder="Select Is it First Time/Expanding Existing"
                                options={FirstTimes}
                            />
                        </Grid>
                        {formData.projectInfo.projectype === ProjectTypeObj.ext || formData.projectInfo.profile === ProfilesObj.Research ? (
                            <Grid item xs={12} md={6}>
                                <CommonFormField
                                    label={`${formData.projectInfo.profile === ProfilesObj.Research ? 'Research' : 'Project'} Name`}
                                    type="email"
                                    name="name"
                                    value={formData.projectInfo.name}
                                    onChange={handleInputChange}
                                    error={errors.name}
                                    placeholder={`Enter ${formData.projectInfo.profile === ProfilesObj.Research ? 'Research' : 'Project'} Name`}
                                />
                            </Grid>
                        ) : (
                            <Grid item xs={12} md={6}>
                                <CommonSelect
                                    label="Project Name"
                                    name="bankid"
                                    value={formData.projectInfo.bankid}
                                    onChange={handleInputChange}
                                    placeholder="Select Project Name"
                                    error={errors.bankid}
                                    options={projectList}
                                />
                            </Grid>
                        )}
                        <Grid item xs={12} md={6}>
                            <CommonSelect
                                label={`${formData.projectInfo.profile === ProfilesObj.Research ? 'Research' : 'Project'} Type`}
                                name="type"
                                value={formData.projectInfo.type}
                                onChange={handleInputChange}
                                placeholder={`Select ${formData.projectInfo.profile === ProfilesObj.Research ? 'research' : 'project'} Type`}
                                error={errors.type}
                                options={Types}
                            />
                        </Grid>
                        {formData.projectInfo.profile === ProfilesObj.Project && (
                            <Grid item xs={12} md={6}>
                                <CommonSelect
                                    label='Project Level'
                                    name="projectlevel"
                                    value={formData.projectInfo.projectlevel}
                                    onChange={handleInputChange}
                                    placeholder='Select Project Level'
                                    options={ProficiencyLevels}
                                />
                            </Grid>
                        )}
                        {formData.projectInfo.profile === ProfilesObj.Project ? (
                            <>
                                <Grid item xs={12} md={6}>
                                    <CommonFormField
                                        label="Duration (Hours)"
                                        type="email"
                                        name="duration"
                                        value={formData.projectInfo.duration}
                                        onChange={handleInputChange}
                                        placeholder='Enter Duration'
                                    />
                                </Grid>
                                {formData.projectInfo.projectype === ProjectTypeObj.ext && (
                                    <Grid item xs={12} md={12}>
                                        <CommonFormField
                                            label='Total Hours (Hours)'
                                            type="email"
                                            name="totalhour"
                                            value={formData.projectInfo.totalhour}
                                            onChange={handleInputChange}
                                            placeholder='Enter Total Hours'
                                        />
                                    </Grid>
                                )}
                            </>
                        ) : (
                            <Grid item xs={12} md={12}>
                                <CommonSelect
                                    label="Select Duration"
                                    name="duration"
                                    value={formData.projectInfo.duration}
                                    onChange={handleInputChange}
                                    placeholder="Select month"
                                    options={ProjectDurations}
                                />
                            </Grid>
                        )}
                        <Grid item xs={12} md={['COMPLETED', 'PAST']?.includes(formData.projectInfo.status) ? 6 : 12}>
                            <CommonFormField
                                label="Start Date"
                                type="date"
                                name="startdate"
                                value={formData.projectInfo.startdate}
                                onChange={handleInputChange}
                                error={errors.startdate}
                                placeholder="Select start date"
                            />
                        </Grid>
                        {['COMPLETED', 'PAST']?.includes(formData.projectInfo.status) && (
                            <Grid item xs={12} md={6}>
                                <CommonFormField
                                    label="End Date"
                                    type="date"
                                    name="enddate"
                                    value={formData.projectInfo.enddate}
                                    onChange={handleInputChange}
                                    placeholder="Select end date"
                                    minDate={getMinDate()}
                                />
                            </Grid>
                        )}
                    </Grid>
                }
                actionButtons={(
                    <Fragment>
                        <CommonButton
                            label="Cancel"
                            size="small"
                            background='white'
                            color={theme.palette.secondary.main}
                            border={`1px solid ${theme.palette.background.secondary}`}
                            fontWeight={700}
                            marginBottom="10px"
                            handleClick={async () => {
                                setFormData((prev) => ({
                                    ...prev,
                                    projectInfo: {
                                        project_id: '',
                                        profile: Profiles[0].value,
                                        projectype: ProjectTypes[0].value,
                                        status: '',
                                        firstTime: FirstTimes[0].value,
                                        name: '',
                                        bankid: '',
                                        type: '',
                                        projectlevel: '',
                                        duration: '',
                                        totalhour: '',
                                        startdate: '',
                                        enddate: '',
                                    },
                                }));
                                setErrors({});
                                setDialogOpen(false)
                            }}
                        />
                        <CommonButton
                            label={formData?.projectInfo?.project_id && formData?.projectInfo?.project_id !== '' ? `Edit ${formData.projectInfo.profile === ProfilesObj.Research ? 'Research' : 'Project'}` : `Add ${formData.projectInfo.profile === ProfilesObj.Research ? 'Research' : 'Project'}`}
                            size="small"
                            background={theme.palette.secondary.main}
                            color={theme.palette.background.main}
                            fontWeight={700}
                            marginBottom="10px"
                            handleClick={() => {
                                handleSubmit();
                            }}
                        />
                    </Fragment>
                )}
            />
            <CommonCard
                borderRadius={1}
                border={`1px solid ${theme.palette.background.secondary}`}
                paddingBottom="0px"
                padding="0px"
                marginTop="0px"
                headerContent={
                    <Box>
                        <Box
                            display="flex"
                            justifyContent="space-between"
                            alignItems="center"
                            p={2}
                        >
                            <Box>
                                <Typography fontSize={22} fontWeight={600}>My STEM Research Projects</Typography>
                                <Typography fontSize={15} color={theme.palette.background.dark}>Manage My Research/Projects</Typography>
                            </Box>
                            {user?.user_type_id === UserTypeId.Student && (
                            <CommonButton
                                label="Add Research/Projects"
                                width="220px"
                                marginBottom="0px"
                                fontWeight={600}
                                startIcon={<Add />}
                                handleClick={() => setDialogOpen(true)}
                            />)}
                        </Box>
                        <Divider />
                    </Box>
                }
                content={
                    <Fragment>
                        <Grid container spacing={1} sx={{ padding: '13px' }}>
                            <Grid item xs={12} md={12} display="flex" gap={1}>
                                <CommonGradeButton
                                    currentGrade={currentGrade}
                                    setCurrentGrade={setCurrentGrade}
                                />
                            </Grid>
                        </Grid>
                        <Box
                            display="flex"
                            gap={1}
                            width="50%"
                            padding={2}
                        >
                            <CommonButton
                                label={`Research (${projects.filter((a) => a.project_profile === 'RESEARCH').length})`}
                                size="small"
                                height="35px"
                                marginBottom="0px"
                                fontWeight="bold"
                                width="20%"
                                background={filter === 'RESEARCH' ? theme.palette.primary.main : theme.palette.background.main}
                                color={filter === 'RESEARCH' ? theme.palette.secondary.main : theme.palette.background.dark}
                                handleClick={() => {
                                    setFilter('RESEARCH');
                                }}
                                border={filter !== 'RESEARCH' ? "1px solid lightgray" : 'none'}
                            />
                            <CommonButton
                                label={`Projects (${projects.filter((a) => a.project_profile === 'PROJECT').length})`}
                                size="small"
                                height="35px"
                                marginBottom="0px"
                                fontWeight="bold"
                                width="20%"
                                background={filter === 'PROJECT' ? theme.palette.primary.main : theme.palette.background.main}
                                color={filter === 'PROJECT' ? theme.palette.secondary.main : theme.palette.background.dark}
                                handleClick={() => {
                                    setFilter('PROJECT');
                                }}
                                border={filter !== 'PROJECT' ? "1px solid lightgray" : 'none'}
                            />
                        </Box>
                        <Grid container spacing={1} sx={{ padding: '13px', marginBottom: 1 }}>
                            {filterProject.map((a, index) => {
                                return (
                                    <Grid item md={6}>
                                        <CommonCard
                                            key={index}
                                            borderRadius={1}
                                            border={`1px solid ${theme.palette.background.secondary}`}
                                            paddingBottom="0px"
                                            padding="13px"
                                            marginTop="0px"
                                            content={
                                                <Fragment>
                                                    <Box
                                                        display="flex"
                                                        justifyContent="space-between"
                                                        alignItems="center"
                                                    >
                                                        {a.project_level ? (
                                                            <Box
                                                                borderRadius={0.6}
                                                                padding="0px 5px"
                                                                sx={{
                                                                    background: theme.palette.secondary.main,
                                                                    border: '1px solid #7A869126'
                                                                }}
                                                            >
                                                                <Typography fontSize={14} color={theme.palette.primary.main}>{ProficiencyLevels.find((i) => i.value === a.project_level)?.label}</Typography>
                                                            </Box>
                                                        ) : <Box />}
                                                        <Box
                                                            display="flex"
                                                            gap={1}
                                                        >
                                                            {user?.user_type_id === UserTypeId.Student && (
                                                            <CommonButton
                                                                label="Edit"
                                                                background="white"
                                                                marginBottom="0px"
                                                                border={`1px solid ${theme.palette.background.secondary}`}
                                                                height="30px"
                                                                width="50px"
                                                                fontWeight={600}
                                                                handleClick={() => {
                                                                    setDialogOpen(true);
                                                                    setFormData((prev) => ({
                                                                        ...prev,
                                                                        projectInfo: {
                                                                            ...prev.projectInfo,
                                                                            project_id: a.project_id,
                                                                            profile: a.project_profile,
                                                                            projectype: a.project_source,
                                                                            status: a.status,
                                                                            firstTime: a.it_first_time,
                                                                            name: a.project_name,
                                                                            bankid: a.project_bank_id,
                                                                            type: a.project_type,
                                                                            projectlevel: a.project_level,
                                                                            duration: a.project_duration,
                                                                            totalhour: a.total_hours,
                                                                            startdate: a.start_date !== null ? moment(a.start_date)?.format('YYYY-MM-DD') : '',
                                                                            enddate: a.end_date !== null ? moment(a.end_date)?.format('YYYY-MM-DD') : '',
                                                                        },
                                                                    }));
                                                                }}
                                                            />)}
                                                        </Box>
                                                    </Box>
                                                    <Typography mt={1} fontWeight={600}>{a.project_name}</Typography>
                                                    <Box
                                                        display="flex"
                                                        gap={1}
                                                        mt={1}
                                                    >
                                                        {a.project_profile === 'PROJECT' && (
                                                            <Box
                                                                display="flex"
                                                                gap={1}
                                                                border={`1px solid ${theme.palette.background.secondary}`}
                                                                borderRadius={0.6}
                                                                padding="0px 5px"
                                                            >
                                                                <Typography fontSize={14}>{ProjectTypes.find((i) => i.value === a.project_source).label}</Typography>
                                                            </Box>
                                                        )}
                                                        <Box
                                                            display="flex"
                                                            gap={1}
                                                            border={`1px solid ${theme.palette.background.secondary}`}
                                                            borderRadius={0.6}
                                                            padding="0px 5px"
                                                        >
                                                            <Typography fontSize={14}>{DisplayGrade[currentGrade]}</Typography>
                                                        </Box>
                                                        <Box
                                                            display="flex"
                                                            gap={1}
                                                            border={`1px solid ${theme.palette.background.secondary}`}
                                                            borderRadius={0.6}
                                                            padding="0px 5px"
                                                        >
                                                            <Typography fontSize={14}>{Academics?.find((i) => i.value === a.status)?.label || Status?.find((i) => i.value === a.status)?.label || '-'}</Typography>
                                                        </Box>
                                                        {a.it_first_time !== '' && (
                                                            <Box
                                                                display="flex"
                                                                gap={1}
                                                                border={`1px solid ${theme.palette.background.secondary}`}
                                                                borderRadius={0.6}
                                                                padding="0px 5px"
                                                            >
                                                                <Typography fontSize={14}>{FirstTimes?.find((i) => i.value === a.it_first_time)?.label || '-'}</Typography>
                                                            </Box>
                                                        )}
                                                        {a.project_type !== '' && (
                                                            <Box
                                                                border={`1px solid ${theme.palette.background.secondary}`}
                                                                borderRadius={0.6}
                                                                padding="0px 5px"
                                                                sx={{
                                                                    background: theme.palette.primary.main
                                                                }}
                                                            >
                                                                <Typography fontSize={14} color={theme.palette.secondary.main}>{Types?.find((i) => i.value === a.project_type)?.label}</Typography>
                                                            </Box>
                                                        )}
                                                    </Box>
                                                    <Box
                                                        display="flex"
                                                        gap={2}
                                                        mt={1}
                                                    >
                                                        <Box>
                                                            <Typography fontSize={14} fontWeight={600}>{a.start_date ? moment(a.start_date).format('DD MMM, YYYY') : '-'}</Typography>
                                                            <Typography fontSize={13} color={theme.palette.background.dark}>Start Date</Typography>
                                                        </Box>
                                                        <Box>
                                                            <Typography fontSize={14} fontWeight={600}>{a.end_date ? moment(a.end_date).format('DD MMM, YYYY') : '-'}</Typography>
                                                            <Typography fontSize={13} color={theme.palette.background.dark}>End Date</Typography>
                                                        </Box>
                                                        <Box>
                                                            <Typography fontSize={14} fontWeight={600}>{a.project_duration ? a.project_profile === 'PROJECT' ? `${a.project_duration} Hours` : ProjectDurations?.find((i) => i.value === a.project_duration)?.label : '-'}</Typography>
                                                            <Typography fontSize={13} color={theme.palette.background.dark}>Duration</Typography>
                                                        </Box>
                                                        {a.type === 2 && (
                                                            <Box>
                                                                <Typography fontSize={14} fontWeight={600}>{a.total_hours || '-'}</Typography>
                                                                <Typography fontSize={13} color={theme.palette.background.dark}>Total Hours</Typography>
                                                            </Box>
                                                        )}
                                                    </Box>
                                                </Fragment>
                                            }
                                        />
                                    </Grid>
                                )
                            })}
                        </Grid>
                    </Fragment>
                }
            />
        </Fragment>
    )
}

export default ResearchInfo;